import isNaN from '@/services/general/isNan';

export default function calculArrondi(valeur, arrondie = 2) {
  if (valeur === null || valeur === undefined || isNaN(valeur)) {
    return null;
  }
  const valeurArrondi = Math.round(Math.abs(valeur) * 10 ** arrondie) / 10 ** arrondie;
  if (valeur < 0 && valeurArrondi !== 0) {
    return -valeurArrondi;
  }
  return valeurArrondi;
}
